import React from 'react'
import Chip from './Chip'
import Participants from './Participants'
import { ArticleData } from '../server/utils/getArticlesData'
import { Link } from 'react-router-dom'

interface Props {
  item: ArticleData
}

const CommunityItem: React.FC<Props> = ({ item }) => {
  return (
    <div className="community-item">
      {!!item.tags?.length && (
        <div className={'community-item__tags row row-gap-8'}>
          {item.tags.map((tag) => (
            <Chip key={tag.label} color={tag.color}>
              {tag.label}
            </Chip>
          ))}
        </div>
      )}

      <div className="community-item__wrapper">
        <Link to={'/communities/' + item.id} className={'text-h4'}>
          {item.title}
        </Link>

        {item.participants && item.participants.count > 0 && (
          <Participants
            className={'community-item__participants'}
            title={''}
            items={item.participants.items}
            count={item.participants.count}
          />
        )}
      </div>
    </div>
  )
}

export default CommunityItem
